/* eslint-disable no-case-declarations */
import {
  getAllElementsService,
  queryElementsService,
} from '../services/contentService';

import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// async thunk
export const getAllElements = createAsyncThunk(
  'elements/getAllElements',
  async () => {
    const response = await getAllElementsService();
    return response.data;
  }
);

export const queryElements = createAsyncThunk(
  'elements/queryElements',
  async (elementIds) => {
    const response = await queryElementsService(elementIds);
    return response.data;
  }
);

export const removeElement = createAsyncThunk(
  'elements/removeElement',
  async (id, { dispatch }) => {
    await getAllElementsService(id);
    dispatch({ type: 'elements/removeElement', id });
  }
);


// slice
const elementsSlice = createSlice({
  name: 'elements',
  initialState: {},
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllElements.pending, (state) => {
        console.log('Fetching all elements...');
        return state;
      })
      .addCase(getAllElements.fulfilled, (state, action) => {
        return { ...state, ...action.payload };
      })
      .addCase(getAllElements.rejected, (state, action) => {
        console.error('Failed to fetch elements:', action.error);
      })
      .addCase(queryElements.pending, (state) => {
        console.log('Querying elements...');
        return state;
      })
      .addCase(queryElements.fulfilled, (state, action) => {
        return { ...state, ...action.payload };
      })
      .addCase(queryElements.rejected, (state, action) => {
        console.error('Failed to query elements:', action.error);
      })
      .addCase(removeElement.pending, (state) => {
        console.log('Removing element...');
        return state;
      })
      .addCase(removeElement.fulfilled, (state, action) => {
        const { [action.meta.arg]: value, ...withoutElement } = state;
        return withoutElement;
      })
      .addCase(removeElement.rejected, (state, action) => {
        console.error('Failed to remove element:', action.error);
      });
  },
});

export default elementsSlice.reducer;
export const elementsActions = elementsSlice.actions;
export const selectElements = state => state.elements;
export const selectElement = (state, id) => state.elements[id];

